import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles(({ palette, breakpoints, spacing }: Theme) => ({
  root: {
    position: 'fixed',
    width: '100%',
    bottom: 0,
    zIndex: 9999,
  },
  cookieWallContainer: {
    [breakpoints.down('xs')]: {
      padding: spacing(0, 2),
    },
    '& .cc-banner__wrapper': {
      margin: spacing(2, 0),
    },
    '& .cc-banner__text': {
      fontSize: '14px',
    },
  },
  bannerTitle: {
    width: '488px',
    '& a': {
      color: palette.secondary.main,
    },
    [breakpoints.down('xs')]: {
      width: '315px',
      marginBottom: '16px',
    },
  },
  cta: {
    width: '180px',
    '& .MuiButton-contained': {
      backgroundColor: palette.success.light,
      boxShadow: 'inherit',
      borderRadius: '2px !important',
    },
    [breakpoints.down('xs')]: {
      width: '315px',
    },
  },
}));

export default styles;
